/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function SquareIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "square", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("rect", { x: 5.5, y: 5.5, width: 14, height: 14, stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(SquareIcon);
export default ForwardRef;
//# sourceMappingURL=squareIcon.js.map